import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../constant-value";
import api from "../../services/axiosConfig";

export const delet = createAsyncThunk("operateDelete/delet", async (action) => {

  try {
    const response = await api.delete(`/api/operate/${action.id}`);
    return response.data;
  } catch (error) {
    console.error(error);  
  }

  // try {
  //   const response = await axios.delete(`${BASE_URL}/api/operate/${action.id}`);
  //   return response.data;
  // } catch (error) {
  //   console.error(error);  
  // }
});

const defaultValue = {};

const deletOperateSlice = createSlice({
  name: "operateDelete",
  initialState: {
    operate: defaultValue,
    isSuccess: false,   // آیا حذف موفق بود
    isLoading: false,
    hasError: false,
  },
  reducers: {
    resetDeleteState: (state) => {
      state.isSuccess = false;
      state.isLoading = false;
      state.hasError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(delet.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
        state.isSuccess = false;
      })
      .addCase(delet.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.isSuccess = true;
      })
      .addCase(delet.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
        state.isSuccess = false;
      });
  },
});

export const { resetDeleteState } = deletOperateSlice.actions;

// Selectors
export const selectDelOperate = (state) => state.operateDelete.operate;
export const selectDeleteOperateSuccessState = (state) => state.operateDelete.isSuccess;
export const selectDelLoadingState = (state) => state.operateDelete.isLoading;
export const selectDelErrorState = (state) => state.operateDelete.hasError;

export default deletOperateSlice.reducer;
